import ApiService from "@/services/api";
import { IApiWalletsWrapper, IAccountSearchParams } from "../interfaces";
import { paginationLimit } from "@/constants";
import steem from "steem";

class AccountService {
  public async find(address: string) {
    const response = await steem.api.getAccountsAsync([address]);
    try {
      /* eslint-disable @typescript-eslint/camelcase */
      response[0].json_metadata = JSON.parse(response[0].json_metadata);
    } catch (error) {
      console.log(error);
    }
    return response[0];
  }

  public async findMany(addresses) {
    const allaccounts = [];
    const response = await steem.api.getAccountsAsync(addresses);
    response.forEach((element) => {
      try {
        element.json_metadata = JSON.parse(element.json_metadata);
      } catch (error) {}
      if (
        element.json_metadata &&
        element.json_metadata.profile &&
        element.json_metadata.profile.about &&
        element.json_metadata.profile.website &&
        element.json_metadata.profile.website.includes("https")
      )
        allaccounts.push(element);
    });
    return allaccounts;
  }

  public async top(page = 1, limit: number = paginationLimit) {
    const response = await ApiService.get("wallets/top", {
      params: {
        page,
        limit,
      },
    });
    return response;
  }

  public async search(
    body: IAccountSearchParams,
    page = 1,
    limit: number = paginationLimit,
  ): Promise<IApiWalletsWrapper> {
    const response = (await steem.api.getAccountsAsync([body.account])) as IApiWalletsWrapper;

    return response[0];
  }
}

export default new AccountService();
